import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Cookies } from 'react-cookie';

import { Redirect } from 'react-router-dom';

import gql from 'graphql-tag';
import { Query, withApollo } from 'react-apollo';

import Wrap from 'components/Wrap';
import Header from 'components/Header';
import Hero from 'components/Hero';
import Form from 'components/Form';
import Overlay from 'components/Overlay';
import Alert from 'components/Alert';
import Loader from 'components/Loader';
import FacebookLogin from 'components/FacebookLogin';

const getSweepstake = gql`
  query getSweepstake($id: ID!) {
    contests(id: $id, active: true, limit: 1) {
      id
      name
      banner
      rules
      questions {
        id
        is_image
        is_video
        multiple_answers
        max_chars
        question
        answers {
          id
          answer
        }
      }
      extra_fields {
        id
        placeholder
        name
      }
      name_required
      email_required
      cc_required
      phone_required
      address_required
      postal_required
      city_required
      meo_id_required
      agreement_required
      name_placeholder
      email_placeholder
      cc_placeholder
      phone_placeholder
      address_placeholder
      postal_placeholder
      city_placeholder
      meo_id_placeholder
      agreement_placeholder
    }
  }
`;

const createParticipationId = gql`
  mutation createParticipationId($contestId: ID!) {
    createParticipation(contest_id: $contestId) {
      participation {
        id
      }
    }
  }
`;

class Sweepstake extends Component {
  constructor(props) {
    super(props);

    const { cookies } = props;

    this.state = {
      participationId: null,
      showCookie: cookies.get('consent') ? false : true,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  createParticipation = () => {
    const contestId = this.props.match.params.id;

    this.props.client
      .mutate({
        mutation: createParticipationId,
        variables: { contestId },
      })
      .then(({ data }) => {
        this.setState({ participationId: data.createParticipation.participation.id });
      })
      .catch(error => console.log(error));
  };

  getQuestionType = question => {
    switch (true) {
      case question.is_image:
        return 'image';
      case question.is_video:
        return 'video';
      case question.multiple_answers:
        return 'radio';
      default:
        return 'textarea';
    }
  };

  mapQuestions = questions => {
    return questions.map(question => {
      question['type'] = this.getQuestionType(question);
      question['name'] = question.id;

      return question;
    });
  };

  onCloseConsent = () => {
    const { cookies } = this.props;

    cookies.set('consent', true, { path: '/' });

    this.setState({
      showCookie: false,
    });
  };

  parseSweepstake = data => {
    data.questions = this.mapQuestions(data.questions);

    return data;
  };

  render() {
    const { participationId, showCookie } = this.state;
    const contestId = this.props.match.params.id;

    return (
      <Query query={getSweepstake} variables={{ id: contestId }}>
        {({ client, loading, error, data }) => {
          if (loading && !data.contests) return <Loader />;
          if (error) return <Alert>Erro! {error.message}</Alert>;

          const sweepstake = data.contests[0];

          return !sweepstake ? (
            <Redirect to="/" />
          ) : (
            <>
              <Wrap>
                <Header img={sweepstake.banner} />
                <Hero {...sweepstake} />
              </Wrap>
              <Form participationId={participationId} settings={this.parseSweepstake(sweepstake)} />
              {showCookie && <Overlay onClose={this.onCloseConsent} />}
              <FacebookLogin onLogin={this.createParticipation} onLogout={() => client.clearStore()} />
            </>
          );
        }}
      </Query>
    );
  }
}

Sweepstake.propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
};

export default withApollo(Sweepstake);
